import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './LoginModal.css';

const REMEMBER_KEY = 'winburst_remember_login';

const LoginModal = () => {
    const { showLoginModal, login, isLoading } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(true);
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Load remembered credentials on mount
    useEffect(() => {
        try {
            const remembered = localStorage.getItem(REMEMBER_KEY);
            if (remembered) {
                const { email: savedEmail, password: savedPassword } = JSON.parse(remembered);
                setEmail(savedEmail || '');
                setPassword(savedPassword || '');
                setRememberMe(true);
            }
        } catch (error) {
            console.error('Failed to load remembered credentials:', error);
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsSubmitting(true);

        const result = await login(email, password);
        
        if (result.success) {
            // Save or clear remembered credentials
            if (rememberMe) {
                localStorage.setItem(REMEMBER_KEY, JSON.stringify({ email, password }));
            } else {
                localStorage.removeItem(REMEMBER_KEY);
            }
        } else {
            setError(result.error || 'Login failed. Please try again.');
        }
        
        setIsSubmitting(false);
    };

    // Prevent body scroll when modal is open
    useEffect(() => {
        if (showLoginModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [showLoginModal]);

    if (!showLoginModal) return null;

    return (
        <div className="login-modal-overlay">
            <div className="login-modal">
                <div className="login-header">
                    <div className="login-logo">
                        <img src="/winburst-logo.png" alt="WinBurst" />
                        <h2>WinBurst</h2>
                    </div>
                </div>
                
                <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={isSubmitting || isLoading}
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={isSubmitting || isLoading}
                        />
                    </div>
                    
                    <div className="form-group remember-me">
                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                checked={rememberMe}
                                onChange={(e) => setRememberMe(e.target.checked)}
                                disabled={isSubmitting || isLoading}
                            />
                            <span>Remember me</span>
                        </label>
                    </div>
                    
                    {error && (
                        <div className="login-error">
                            {error}
                        </div>
                    )}
                    
                    <button 
                        type="submit" 
                        className="login-submit-btn"
                        disabled={isSubmitting || isLoading}
                    >
                        {isSubmitting || isLoading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginModal;